import { type AxiosRequestConfig } from 'axios';
import type { AxiosDataReturn, PaginatedResponse } from '../types/generic';
import api from './api-instance';
import { toast } from 'react-toastify';
import type { TSponsor } from '../types/sponsors';
import type { TLearner } from '../types/learner';

export const sponsorsList = async (args?: AxiosRequestConfig<any>) => {
  try {
    const res = await api.get<AxiosDataReturn<PaginatedResponse<TSponsor>>>(
      '/sponsors/admin',
      args
    );
    return res?.data?.data;
  } catch (e) {
    toast.error('Something went wrong', { toastId: 'api-error' });
    throw e;
  }
};

export const learnerListBySponsorId = async (
  sponsorId: string,
  args?: AxiosRequestConfig<any>
) => {
  try {
    const res = await api.get<AxiosDataReturn<PaginatedResponse<TLearner>>>(
      `/sponsors/admin/learners/${sponsorId}`,
      args
    );
    return res?.data?.data;
  } catch (e) {
    toast.error('Something went wrong', { toastId: 'api-error' });
    throw e;
  }
};
